export class Cancelacion {
    /**Poliza Id encriptado */
    polizaId: string = "";
    razon: string = "";
    motivo: string = "";
    /**ColectividadId encriptado */
    colectividadId?: string;
    worksiteId: number = 3;
    /**Bandera para definir cuando genera el endoso pendiente y luego lo pasa a vigente */
    aplicarEndoso?: boolean = false;
    /** Numero de Endoso */
    endoso: string = "";
    /** endosoId encriptado */
    endosoId: string = "";
    /**Bandera para definir como aplica el endoso */
    /** 0 o null => Proceso de endoso normal */
    /** 1 => Proceso de endoso por bandera aplicarEndoso */
    /** 2 => Proceso de endoso que genera automaticamente la baja directa */
    opcion?: number = 0;
    polizaIdComplemento?:string;
    endosoIdComplemento?: string;
}

export class CancelacionQualAfir {
    /**Poliza Id encriptado */
    v1: string = "";
    /**Razon */
    v2: string = "";
    /**Motivo */
    v3: string = "";
    /**ColectividadId encriptado */
    v4?: string;
    /**WorksiteId */
    v5: number = 3;
    /**Bandera para definir cuando genera el endoso pendiente y luego lo pasa a vigente */
    v6: number = 0;
    /** Numero de Endoso */
    v7?: string = "";
    /** Poliza id Complemento */
    polizaIdComplemento?:string;
    /** Endoso id Complemento */
    endosoIdComplemento?: string;
}